import React from "react";
import { LdsRoller } from "../LdsRoller";
import LoadingStyles from "../WorkspaceDialog.module.css";

type ProgressProps = {
  title: string;
  progress?: { step: string; processed?: number; total?: number };
};

export const Progress: React.FC<ProgressProps> = ({ title, progress }) => {
  return (
    <>
      <div className={LoadingStyles.header}>
        <span className={LoadingStyles.title}>{title}</span>
      </div>
      <LdsRoller />
      {progress && (
        <div className={LoadingStyles.loading}>
          <Percentage {...progress} /> {progress.step}
        </div>
      )}
    </>
  );
};

const Percentage: React.FC<{ processed?: number; total?: number }> = ({
  processed,
  total,
}) => {
  if (!processed || !total) return "";
  const formatter = new Intl.NumberFormat();
  return `${formatter.format(processed)} of ${formatter.format(
    total,
  )} (${Math.floor((processed / total) * 100)}%)`;
};
